import React from 'react';
import { QuestionnaireItem } from '../QuestionnairePreview';
// @ts-ignore
import styles from './../QuestionnairePreview.module.scss';
import { QuestionnaireItemSubtype } from '../../../Enums/QuestionnaireItemSubtype.enum';
import QuestionnairePreviewItems from '../QuestionnairePreviewItems';
import Text from '../../../../../Components/Base/Text/Text';
import useTranslation from '../../../../../Hooks/useTranslation';

interface Props {
	item: QuestionnaireItem;
}

const QuestionnairePreviewOnSubmit: React.FC<Props> = ({ item }) => {
	const { t } = useTranslation();

	const renderItem = ({
		item,
		title,
		titleClass,
		wrapperClass,
		wrapperItem,
	}: {
		item: QuestionnaireItem;
		title: string;
		titleClass: string;
		wrapperClass: string;
		wrapperItem?: {
			className: string;
			icon: {
				url: string;
				alt: string;
			};
		};
	}) => (
		<div className={styles.subItem}>
			<div className={titleClass}>{t(title)}:</div>
			<div className={wrapperClass}>
				{wrapperItem && (
					<div className={wrapperItem.className}>
						<img src={wrapperItem.icon.url} alt={wrapperItem.icon.alt} />{' '}
						{item.description}
					</div>
				)}
				<QuestionnairePreviewItems children={item.children} />
			</div>
		</div>
	);

	switch (item.subtype) {
		case QuestionnaireItemSubtype.ADD_QUESTION:
		case QuestionnaireItemSubtype.PREPEND_QUESTION:
			return renderItem({
				item: item,
				title: 'component.questionnairePreview.addingQuestionsAfterPick',
				titleClass: styles.addQuestions,
				wrapperClass: styles.addQuestionsWrapper,
			});
		case QuestionnaireItemSubtype.SHOW_NOTIFICATION:
			return renderItem({
				item: item,
				title: 'component.questionnairePreview.addingWarningAfterPick',
				titleClass: styles.addWarning,
				wrapperClass: styles.addWarningWrapper,
				wrapperItem: {
					className: styles.addWarningItem,
					icon: {
						url: '/dist/icons/alert-orange.svg',
						alt: 'warning-triangle',
					},
				},
			});
		case QuestionnaireItemSubtype.SHOW_ALERT:
			return renderItem({
				item: item,
				title: 'component.questionnairePreview.addingAlertAfterPick',
				titleClass: styles.addAlert,
				wrapperClass: styles.addAlertWrapper,
				wrapperItem: {
					className: styles.addAlertItem,
					icon: {
						url: '/dist/icons/alert-red.svg',
						alt: 'alert-triangle',
					},
				},
			});
		default:
			return <Text tx='component.questionnairePreview.unsupportedItem' />;
	}
};

export default QuestionnairePreviewOnSubmit;
